import { render, staticRenderFns } from "./DoctorService.vue?vue&type=template&id=587b9816&scoped=true"
import script from "./DoctorService.vue?vue&type=script&lang=js"
export * from "./DoctorService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b9816",
  null
  
)

export default component.exports